/**
 * Insight API Service
 * 
 * This module contains API functions for insights
 */

import { Insight } from '../types/insight';
import { API_CONFIG } from '../config/env';

/**
 * Generic error handler for API requests
 */
const handleApiError = (error: any): never => {
  console.error('API Error:', error);
  throw new Error(error.message || 'An unknown error occurred');
};

/**
 * Fetch insights from the API
 */
export const fetchInsights = async (): Promise<Insight[]> => {
  try {
    // In a real app, this would be a real API call
    // const response = await fetch(`${API_CONFIG.BASE_URL}/api/${API_CONFIG.VERSION}/insights`);
    // if (!response.ok) throw new Error('Failed to fetch insights');
    // return await response.json();
    
    // For now, return mock data
    return mockInsights;
  } catch (error) {
    return handleApiError(error);
  }
};

/**
 * Like/unlike an insight
 */
export const toggleLikeInsight = async (insightId: string, isLiked: boolean): Promise<{ success: boolean }> => {
  try {
    // In a real app, this would be a real API call
    // const response = await fetch(`${API_CONFIG.BASE_URL}/api/${API_CONFIG.VERSION}/insights/${insightId}/like`, {
    //   method: isLiked ? 'DELETE' : 'POST',
    //   headers: { 'Content-Type': 'application/json' }
    // });
    // if (!response.ok) throw new Error('Failed to update like status');
    // return await response.json();
    
    // For now, return success
    return { success: true };
  } catch (error) {
    return handleApiError(error);
  }
};

/**
 * Pin/unpin an insight
 */
export const togglePinInsight = async (insightId: string, isPinned: boolean): Promise<{ success: boolean }> => {
  try {
    // In a real app, this would be a real API call
    // const response = await fetch(`${API_CONFIG.BASE_URL}/api/${API_CONFIG.VERSION}/insights/${insightId}/pin`, {
    //   method: isPinned ? 'DELETE' : 'POST',
    //   headers: { 'Content-Type': 'application/json' }
    // });
    // if (!response.ok) throw new Error('Failed to update pin status');
    // return await response.json();
    
    // For now, return success
    return { success: true };
  } catch (error) {
    return handleApiError(error);
  }
};

// Mock insights data
export const mockInsights: Insight[] = [
  {
    id: '1',
    title: 'The Forgotten Coast',
    description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit ut at massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien. Lorem ipsum dolor sit amet consectetur adipiscing hendrerit.',
    imageUrl: 'https://images.unsplash.com/photo-1559825481-12a05cc00344',
    brand: {
      id: 'b1',
      name: 'Kayak',
      logo: '/brand-logos/kayak-orange.svg',
      creator: 'Kevin Smith'
    },
    likes: 124,
    comments: 32,
    isLiked: false,
    isPinned: false,
    createdAt: '2025-05-28T10:30:00Z'
  },
  {
    id: '2',
    title: 'Mountain Exploration',
    description: 'Discover the hidden gems of the mountain range with our expert guides. Experience breathtaking views and challenging trails designed for adventurers of all levels.',
    imageUrl: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b',
    brand: {
      id: 'b2',
      name: 'Trek Adventures',
      logo: '/brand-logos/trek-blue.svg',
      creator: 'Sarah Johnson'
    },
    likes: 89,
    comments: 17,
    isLiked: true,
    isPinned: false,
    createdAt: '2025-05-27T14:20:00Z'
  },
  {
    id: '3',
    title: 'Urban Photography Guide',
    description: 'Master the art of urban photography with these essential tips and tricks. Learn how to capture the essence of city life through your lens.',
    imageUrl: 'https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b',
    brand: {
      id: 'b3',
      name: 'PixelPro',
      logo: '/brand-logos/pixel-purple.svg',
      creator: 'Michael Chen'
    },
    likes: 215,
    comments: 42,
    isLiked: false,
    isPinned: true,
    createdAt: '2025-05-25T09:15:00Z'
  },
  {
    id: '4',
    title: 'Sustainable Fashion Trends',
    description: 'Explore the latest trends in sustainable fashion and how eco-friendly materials are revolutionizing the industry. Discover brands making a difference.',
    imageUrl: 'https://images.unsplash.com/photo-1490481651871-ab68de25d43d',
    brand: {
      id: 'b4',
      name: 'EcoStyle',
      logo: '/brand-logos/eco-green.svg',
      creator: 'Emma Rodriguez'
    },
    likes: 167,
    comments: 28,
    isLiked: false,
    isPinned: false,
    createdAt: '2025-05-23T16:45:00Z'
  },
  {
    id: '5',
    title: 'Culinary Adventures',
    description: 'Embark on a global culinary journey with these exotic recipes from around the world. Learn techniques from master chefs and impress your guests.',
    imageUrl: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0',
    brand: {
      id: 'b5',
      name: 'GourmetWorld',
      logo: '/brand-logos/gourmet-orange.svg',
      creator: 'Jean-Pierre Dubois'
    },
    likes: 142,
    comments: 36,
    isLiked: true,
    isPinned: false,
    createdAt: '2025-05-21T11:30:00Z'
  },
  {
    id: '6',
    title: 'Digital Nomad Lifestyle',
    description: 'Learn how to balance work and travel as a digital nomad. Tips for productivity, finding accommodations, and building a sustainable remote career.',
    imageUrl: 'https://images.unsplash.com/photo-1508385082359-f38ae991e8f2',
    brand: {
      id: 'b6',
      name: 'RemoteLife',
      logo: '/brand-logos/remote-blue.svg',
      creator: 'Alex Morgan'
    },
    likes: 198,
    comments: 45,
    isLiked: false,
    isPinned: true,
    createdAt: '2025-05-19T08:20:00Z'
  }
];
